import { Link } from "react-router-dom";
import type { Novel } from "@/lib/novel";
import { formatCount } from "@/lib/novel";

export default function HotRanking({ items }: { items: Novel[] }) {
  return (
    <ol className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {items.map((novel, index) => (
        <li key={novel.id}>
          <Link
            to={`/detail/${novel.id}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                index < 3
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {index + 1}
            </span>
            <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={novel.cover}
                alt={`${novel.title} 封面`}
                title={`${novel.title} 在线阅读 - 御书屋`}
                className="h-full w-full object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {novel.title}
              </h3>
              <p className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                <span className="truncate">{novel.author}</span>
                <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                  {novel.categoryName}
                </span>
              </p>
            </div>
            <span className="flex shrink-0 flex-col items-end text-xs text-foreground-400">
              <span className="flex items-center gap-1 text-accent-600">
                <i className="ri-fire-line"></i>
                {formatCount(novel.clicks)}
              </span>
              <span className="mt-1 flex items-center gap-1">
                <i className="ri-bookmark-line"></i>
                {formatCount(novel.favorites)}
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}